export const INVITE_STEPS = [
  {
    icon: 'email',
    id: 'user-details',
    label: 'User details'
  },
  {
    icon: 'lockOpen',
    id: 'roles-and-groups',
    label: 'Roles and groups'
  },
  {
    icon: 'visibility',
    id: 'review',
    label: 'Review'
  }
];

export const STEP_IDS = {
  USER_DETAILS: 'user-details',
  ROLES_AND_GROUPS: 'roles-and-groups',
  REVIEW: 'review'
};

